import { useCallback, useEffect, useState } from 'react';
import type { MemberWorkspaceListItem } from 'shared';
import { api } from '../utils/api';
import { toErrorMessage } from '../lib/errors';

export type MemberWorkspace = MemberWorkspaceListItem;

/**
 * The workspaces the signed-in member belongs to.
 *
 * Mounted once by MemberLayout; pages read the result through
 * `useMemberWorkspaces()` rather than fetching it again.
 */
export function useMyWorkspaces() {
  const [workspaces, setWorkspaces] = useState<MemberWorkspace[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const refresh = useCallback(async () => {
    try {
      const response = await api.get<{ data: MemberWorkspace[] }>('/api/me/workspaces');
      setWorkspaces(response.data);
      setError(null);
    } catch (err) {
      setError(toErrorMessage(err));
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { workspaces, loading, error, refresh };
}
